module.exports = __webpack_public_path__ + "img/no_data_notice.42f5ae19.png";